var service = {
    mapLibraries: ['places'],
    API_URL: process.env.REACT_APP_API_URL
    // API_URL: 'http://192.168.1.52:5000'
    // API_URL: 'https://dev-api.emfora.in'
    // service.API_URL = 'https://blackbox.teamfeeltech.com';
    // service.API_URL = https://dev-api.emfora.in
};

export default service;
